import { RouteObject } from "react-router-dom";
import { useEffect } from "react";
import { Box } from "@mui/material";
import {
  useIsIndividualContributor,
  useLocation,
  useNavigate,
} from "../../modules/common";
import {
  BoBrainActivityDetailSection,
  BoBrainActivityHeaderSection,
  BoZoneActivityDetailSection,
  BoZoneActivityHeaderSection,
} from "../../modules";
import SiteLoadingPageWithOverlay from "app/storybookComponents/Loading/SiteLoadingPageWithOverlay";
import { UserLayout } from "./UserLayout";
import { DashboardActivity } from "./DashboardActivity/DashboardActivity";
import { TeamActivity } from "./TeamActivity/TeamActivity";
import { ChatWithBoActivity } from "./ChatWithBoActivity/ChatWithBoActivity";
import { CalendarActivity } from "./CalendarActivity/CalendarActivity";
import { CheckInActivity } from "./CheckInActivity/CheckInActivity";

export const root: RouteObject = {
  path: "user",
  element: <Redirect />,
  children: [
    {
      path: "boZone",
      element: (
        <UserLayout>
          <Box paddingTop="1rem">
            <BoZoneActivityHeaderSection />
          </Box>
          <BoZoneActivityDetailSection />
        </UserLayout>
      ),
    },
    {
      path: "boBrain",
      element: (
        <UserLayout banner={<BoBrainActivityHeaderSection />}>
          <BoBrainActivityDetailSection />
        </UserLayout>
      ),
    },
    {
      path: "dashboard",
      element: <DashboardActivity />,
    },
    {
      path: "team",
      element: <TeamActivity />,
    },
    {
      path: "chatWithBo",
      element: <ChatWithBoActivity />,
    },
    {
      path: "checkIn",
      element: <CheckInActivity />,
    },
    {
      path: "calendar",
      element: <CalendarActivity />,
    },
  ],
};

function Redirect() {
  const location = useLocation();
  const navigate = useNavigate();
  const isIndividualContributor = useIsIndividualContributor();

  useEffect(() => {
    if (isIndividualContributor === undefined) return;
    navigate(
      `${location.pathname}/${isIndividualContributor ? "boZone" : "dashboard"}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIndividualContributor]);

  return <SiteLoadingPageWithOverlay />;
}
